const writeTextToClipboard = async (event, data) => {
  var _a, _b;
  if (data === void 0) {
    return;
  }
  let error;
  if (event && "clipboardData" in event && ((_a = event.clipboardData) == null ? void 0 : _a.setData)) {
    try {
      return await event.clipboardData.setData("text/plain", data);
    } catch (e) {
      error = e;
    }
  }
  if ((_b = navigator == null ? void 0 : navigator.clipboard) == null ? void 0 : _b.writeText) {
    try {
      await navigator.clipboard.writeText(data);
    } catch (e) {
      console.warn(error, e);
    }
  }
};
const formatCellValueAsString = (cell) => {
  var _a, _b, _c;
  if (cell.columnDisabled || cell.value === void 0 || cell.value === null) {
    return "";
  }
  let stringValue = "";
  if (typeof cell.value === "object") {
    if ((_a = cell.value) == null ? void 0 : _a.length) {
      stringValue = cell.value.map((item) => {
        if (typeof item === "object") {
          return (item == null ? void 0 : item.value) ?? (item == null ? void 0 : item.label) ?? "";
        }
        return item;
      }).join(", ");
    } else {
      stringValue = `${((_b = cell.value) == null ? void 0 : _b.value) ?? ((_c = cell.value) == null ? void 0 : _c.label) ?? ""}`;
    }
  } else {
    stringValue = `${cell.value}`;
  }
  if (stringValue.includes(`
`)) {
    if (stringValue.includes(`"`)) {
      stringValue = stringValue.replace(/"/gi, `""`);
    }
    stringValue = `"${stringValue}"`;
  }
  return stringValue;
};
const createClipboardText = (cells) => {
  return cells.reduce((memo, cell, index) => {
    const nextCell = cells[index + 1];
    const nextCellIsNewRow = (nextCell == null ? void 0 : nextCell.rowIndex) === cell.rowIndex + 1 || (nextCell == null ? void 0 : nextCell.rowIndex) > cell.rowIndex;
    memo += formatCellValueAsString(cell);
    if (nextCellIsNewRow) {
      memo += "\n";
    } else if (nextCell) {
      memo += "	";
    }
    return memo;
  }, "");
};
const NEW_LINE_NOT_INSIDE_DOUBLE_QUOTES = /\n(?=(?:(?:[^"]*"){2})*[^"]*$)/;
const TAB_NOT_INSIDE_DOUBLE_QUOTES = /\t(?=(?:(?:[^"]*"){2})*[^"]*$)/;
const getClipboardData = (clipboardText) => {
  return clipboardText.replace(/^(?:\r?\n)+|(?:\r?\n)+$/g, "").split(NEW_LINE_NOT_INSIDE_DOUBLE_QUOTES).map(
    (line) => line.split(TAB_NOT_INSIDE_DOUBLE_QUOTES).map((cell, columnIndex, columns) => {
      if (cell.startsWith('"') && cell.endsWith('"') && /\n/.test(cell)) {
        return cell.slice(1, -1).replaceAll("	", "        ").replaceAll(`""`, `"`);
      }
      if (columnIndex === columns.length - 1) {
        return cell.replace(/\r+$/, "");
      }
      return cell;
    })
  );
};
export {
  createClipboardText,
  formatCellValueAsString,
  getClipboardData,
  writeTextToClipboard
};
